import React, { FC } from 'react'
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet'
import L from 'leaflet'
import ReactDOMServer from 'react-dom/server'

import { HERE_TILE_URL } from '../constants'
import { VehiclePosition } from '../types'
import CurrentPositionMarker from './CurrentPositionMarker'
import MapPopup from './MapPopup'
import PreviousPositionMarker from './PreviousPositionMarker'

interface MapProps {
  vehicles?: VehiclePosition[]
}

const FitBounds: FC<MapProps> = ({ vehicles }) => {
  const map = useMap()
  if (vehicles) {
    map.fitBounds(
      vehicles.map((position) => [position.lat, position.lon]),
      { padding: [50, 50] }
    )
  }
  return null
}

const previousPositionMarker = L.divIcon({
  html: ReactDOMServer.renderToString(<PreviousPositionMarker />),
  iconAnchor: [12, 32],
  iconSize: [0, 0], // to remove inital div of Leaflet
})

const Map: FC<MapProps> = ({ vehicles }) => {
  const defaults = {
    latitude: 51.2603015,
    longitude: 4.2176376,
    zoom: 13,
  }

  const markers =
    vehicles &&
    vehicles.map((vehicle, index) => (
      <Marker
        key={`${vehicle.ts}-${vehicle.lat}-${vehicle.lon}-${index}`}
        position={[vehicle.lat, vehicle.lon]}
        icon={
          index === 0
            ? L.divIcon({
                html: ReactDOMServer.renderToString(
                  <CurrentPositionMarker
                    isLastKnownPosition={vehicle.isLastKnownPosition}
                  />
                ),
                iconAnchor: [18, 51],
                iconSize: [0, 0], // to remove inital div of Leaflet
              })
            : previousPositionMarker
        }
      >
        <MapPopup vehicle={vehicle} />
      </Marker>
    ))

  return (
    <MapContainer
      style={{ flex: '1 1 auto' }}
      center={[defaults.latitude, defaults.longitude]}
      zoom={defaults.zoom}
    >
      <TileLayer url={HERE_TILE_URL} />
      {markers}
      <FitBounds vehicles={vehicles} />
    </MapContainer>
  )
}
export default Map
